module.exports = __webpack_public_path__ + "static/media/tissue.30cde8bc.webp";